/**
 * A card's picture: the shot rendered when its version was saved, or, until
 * there is one, the drawing of its kind (a folder is always its drawing).
 */
import useAssetThumb from '../../hooks/useAssetThumb';
import type { AssetRow } from '../../engine/assets/types';
import AssetGlyph from './AssetGlyph';

interface Props {
  uid: string;
  asset: AssetRow;
  className: string;
}

export default function AssetThumb({ uid, asset, className }: Props) {
  const url = useAssetThumb(uid, asset);
  if (!url) return <AssetGlyph kind={asset.kind} className={className} />;
  return <img className={className} src={url} alt="" data-testid={`asset-thumb-${asset.id}`} />;
}
